import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "@reduxjs/toolkit";
import { config } from "@/lib/config";

// Import slices
import authReducer from "./slices/authSlice";
import propertyReducer from "./slices/propertySlice";
import agentReducer from "./slices/agentSlice";
import filterReducer from "./slices/filterSlice";
import uiReducer from "./slices/uiSlice";
import customerDashboardReducer from "./slices/customer/customerDashboardSlice";
import customerProfileReducer from "./slices/customer/customerProfileSlice";
import customerBookingsReducer from "./slices/customer/customerBookingsSlice";
import userManagementReducer from "./slices/userManagementSlice";
import agentAssignmentReducer from "./slices/agentAssignmentSlice";
import agentCustomerViewReducer from "./slices/agentCustomerViewSlice";

// Persist config
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth", "filters", "ui"], // Only persist these reducers
};

const rootReducer = combineReducers({
  auth: authReducer,
  properties: propertyReducer,
  agents: agentReducer,
  filters: filterReducer,
  ui: uiReducer,
  customerDashboard: customerDashboardReducer,
  customerProfile: customerProfileReducer,
  customerBookings: customerBookingsReducer,
  userManagement: userManagementReducer,
  agentAssignment: agentAssignmentReducer,
  agentCustomerView: agentCustomerViewReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }),
  devTools: config.app.environment !== "production",
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Typed hooks for use throughout the app
import { useDispatch, useSelector, TypedUseSelectorHook } from "react-redux";

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
